import React, { FC } from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';
import { FormDataType } from 'contexts/FormProvider';
import { useContentContext } from '@qbe/dfc-content';
import { Button, FormGroupLabel } from '@qbe/ads-core';
import { FormCard } from '@qbe/ads-blocks-forms';
import { FormSpacer } from 'components';
import { TextFieldController } from 'controllers';
import { useContentComplaintPartners } from 'utils/content';

interface Props {
  form: UseFormReturn<FormDataType>;
  isFieldRequired: (fieldName: string) => boolean;
  showNextButton: boolean;
  isValid: boolean;
  show: boolean;
}

const ContactDetails: FC<Props> = (props) => {
  const { form, show, isFieldRequired, showNextButton = true, isValid = false } = props;

  const { getTextContent } = useContentComplaintPartners({ context: useContentContext() });

  const { control } = form;

  if (!show) return null;

  return (
    <>
      <FormCard variant="sectionTitle" title={getTextContent('fha.contact.details.header')}>
        <FormGroupLabel
          alignCenter
          legendElementOveride
          title={getTextContent('consent.contactDetails.email')}
          required={isFieldRequired('emailAddress')}
        />
        <FormSpacer type="input" />
        <TextFieldController
          control={control}
          label={getTextContent('consent.contactDetails.emailAddress.label')}
          name="emailAddress"
          maxLength={100}
          inputProps={{
            maxLength: 100,
          }}
          capture
        />

        <FormGroupLabel
          alignCenter
          legendElementOveride
          title={getTextContent('consent.contactDetails.phoneNumber')}
          required={isFieldRequired('phoneNumber')}
        />
        <FormSpacer type="input" />
        <TextFieldController
          control={control}
          label={getTextContent('consent.contactDetails.phoneNumber.label')}
          name="phoneNumber"
          inputProps={{
            maxLength: 20,
          }}
          capture
        />

        <FormSpacer type="formgroup" />

        {showNextButton && <Button type="submit" label={getTextContent('continue.label')} disabled={!isValid} />}
      </FormCard>
    </>
  );
};

export default ContactDetails;
